import ResultCard from './ResultCard'
import { displayValue } from './chatFormatters'
import { CargoTracking } from './types'
import YurticiTrackingButton from './YurticiTrackingButton'

interface Props {
  tracking: CargoTracking
  titleId?: string
}

/** Kargo takip sonucu. Modalda ve sohbet balonunda aynı kart gösterilir. */
export default function CargoTrackingCard({ tracking, titleId }: Props) {
  return (
    <ResultCard
      titleId={titleId}
      eyebrow={`Sipariş ${tracking.orderNumber}`}
      title={displayValue(tracking.statusDescription || tracking.cargoEventDescription)}
      badge={`Durum ${tracking.statusCode}`}
      items={[
        { label: 'Teslimat no', value: displayValue(tracking.deliveryNumber) },
        { label: 'Kargo takip no', value: displayValue(tracking.cargoNumber) },
        { label: 'Kargo hareketi', value: displayValue(tracking.cargoEventDescription) },
        { label: 'Teslim tarihi', value: displayValue(tracking.deliveryWhen) },
        { label: 'Varış merkezi', value: displayValue(tracking.arrivalCenter) },
        { label: 'Belge no', value: displayValue(tracking.documentId) },
        { label: 'Teslim alan', value: displayValue(tracking.receiverName) },
        { label: 'Açıklama', value: displayValue(tracking.cargoExplanation), wide: true },
        { label: 'Teslimat adresi', value: displayValue(tracking.receiverAddress), wide: true },
      ]}
      footer={tracking.trackingUrl ? <YurticiTrackingButton url={tracking.trackingUrl} /> : undefined}
    />
  )
}
